import { render } from "./vadvertappeal.vue?vue&type=template&id=6c463a1d&scoped=true"
import script from "./vadvertappeal.vue?vue&type=script&lang=js"
export * from "./vadvertappeal.vue?vue&type=script&lang=js"

import "./vadvertappeal.vue?vue&type=style&index=0&id=6c463a1d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c463a1d"]])

export default __exports__